export const GOOGLE_API_KEY = 'AIzaSyAht19NYs2_g6hDAXsDhVcjXOGEYnaVxwE';
